import { getToken } from '@/utils/auth'
const state = {
  token: getToken(),
  oid:1,
  ws:'',
}

const mutations = {
  INIT: (state, name) => {
    if(process.env.NODE_ENV == 'development'){
      state.ws = new WebSocket("ws://ws.course.yiihuu.com:18308/videoStats?token="+state.token+"&oid="+state.oid);
    }else if(process.env.NODE_ENV == 'production'){
      state.ws = new WebSocket("wss://ws.ke.yiihuu.com/videoStats?token="+state.token);
    }else{
      state.ws = new WebSocket("ws://ws.course.yiihuu.com:18308/videoStats?token="+state.token);
    }
    state.ws.onopen = (evt) => {
      console.log('消息ws开启',evt);
    };
    state.ws.onmessage = (evt) =>{
      console.log('消息ws开启,接收到广播回来的数据：',evt);
    };
    state.ws.onclose = (evt) => {
      console.log('消息ws开启,页面关闭：',evt);
    };
    state.ws.onerror = (err)=>{
      console.log('消息ws出现错误。',err)
    };
  },
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/infows.js